export default __webpack_public_path__ + "static/media/analisis_de_datos_mediciones-antropometricas.77254f03.png";